const specialsData = [
    {
      image: "/bruchetta.svg",
      name: "Bruchette",
      price: "12.99",
      description: "Our Bruchette is made from grilled bread that has been smeared with garlic and seasoned with salt and olive oil."
    },
    {
      image: "/greek-salad.jpg",
      name: "Greek Salad",
      price: "12.99",
      description: "The famous Greek salad with crispy lettuce, peppers, olives, feta cheese, and crunchy garlic rosemary croutons."
    },
    {
      image: "lemon-dessert.jpg",
      name: "Lemon Dessert",
      price: "12.99",
      description: "This comes straight from grandma's recipe book, with carefully sourced ingredients."
    },
    {
      name: "Hummus Layered Dip",
      price: "7.99",
      image: "https://www.savingdessert.com/wp-content/uploads/2019/03/Greek-Layered-Hummus-Dip-1.jpg",
      description: "A delicious blend of hummus, roasted red peppers, olives, and herbs served with warm pita."
    }
  ];
  
  export default specialsData;
  